export const NAVIGATION = 'NAVIGATION';
export const REDIRECT_MAINTENANCE = 'REDIRECT_MAINTENANCE';